var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.rm
    ? _c(
        "div",
        [
          _vm.isWorkspaceMember
            ? _c("PortfolioNavigation", {
                attrs: {
                  workspaceId: _vm.workspaceId,
                  projectId: _vm.tchProjectId,
                },
              })
            : _c("Navigation"),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "container-fluid",
              staticStyle: { "margin-top": "80px", "padding-top": "40px" },
            },
            [
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-lg-6 d-flex align-items-center" },
                  [
                    !_vm.isWorkspaceMember
                      ? _c(
                          "h1",
                          {
                            staticStyle: {
                              "font-size": "2em",
                              "font-weight": "300",
                              color: "#33475b",
                              margin: "0",
                            },
                          },
                          [
                            _vm._v(
                              "\n                    P&L: " +
                                _vm._s(_vm.viewDefName) +
                                "\n                "
                            ),
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isWorkspaceMember
                      ? _c(
                          "h1",
                          {
                            staticStyle: {
                              "font-size": "2em",
                              "font-weight": "300",
                              color: "#33475b",
                              margin: "0",
                            },
                          },
                          [_vm._v("P&L:")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.isWorkspaceMember
                      ? _c("div", { staticClass: "dropdown ml-2" }, [
                          _c(
                            "a",
                            {
                              staticClass: "btn btn-link",
                              staticStyle: { "font-size": "2em", padding: "0" },
                              attrs: { "data-toggle": "dropdown" },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.viewDefName) +
                                  " "
                              ),
                              _c("i", {
                                staticClass: "fa fa-caret-down",
                                staticStyle: {
                                  "font-size": "0.7em",
                                  "vertical-align": "middle",
                                },
                              }),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "dropdown-menu dropdown-menu-scrollable",
                              attrs: { role: "menu" },
                            },
                            [
                              _c(
                                "a",
                                {
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setViewDefId(null)
                                    },
                                  },
                                },
                                [_vm._v("All")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "dropdown-divider" }),
                              _vm._v(" "),
                              _c("h6", { staticClass: "dropdown-header" }, [
                                _vm._v("Custom lists"),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.views, function (v) {
                                return _c(
                                  "a",
                                  {
                                    key: v.Id,
                                    staticClass: "dropdown-item",
                                    on: {
                                      click: function ($event) {
                                        return _vm.setViewDefId(v.Id)
                                      },
                                    },
                                  },
                                  [_vm._v(_vm._s(v.Name))]
                                )
                              }),
                            ],
                            2
                          ),
                        ])
                      : _vm._e(),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "col-lg-6 text-right align-self-end" },
                  [
                    _vm.isWorkspaceMember
                      ? _c(
                          "a",
                          {
                            staticClass: "btn btn-outline-secondary",
                            staticStyle: { padding: "0.7em 2em" },
                            attrs: {
                              href: `/#/sharing/resource/PortfolioPnlsDataShareResourceProvider/${_vm.shareId}`,
                              target: "_blank",
                            },
                          },
                          [
                            _vm._v("\n                    Share "),
                            _vm.activeSharesCount
                              ? _c("span", [
                                  _vm._v(
                                    "(" + _vm._s(_vm.activeSharesCount) + ")"
                                  ),
                                ])
                              : _vm._e(),
                          ]
                        )
                      : _vm._e(),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("hr", {
                staticStyle: { "border-color": "#bbb", margin: "20px 0 20px" },
              }),
              _vm._v(" "),
              _c(
                "nav",
                {
                  staticClass: "navbar navbar-light navbar-expand-md bg-light",
                  attrs: { role: "navigation" },
                },
                [
                  _c(
                    "button",
                    {
                      staticClass: "btn mr-2",
                      class: _vm.applyBenefitsConfidenceFactor
                        ? "btn-danger"
                        : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.toggleBenefitsConfidenceFactor()
                        },
                      },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-regular",
                        class: _vm.applyBenefitsConfidenceFactor
                          ? "fa-square-check"
                          : "fa-square",
                      }),
                      _vm._v(
                        "\n                Risk adjusted benefits\n            "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "button",
                    {
                      staticClass: "btn mr-2",
                      class: _vm.cagrVisible
                        ? "btn-info"
                        : "btn-outline-secondary",
                      attrs: { type: "button" },
                      on: { click: _vm.toggleCagr },
                    },
                    [
                      _c("i", {
                        staticClass: "fa-regular",
                        class: _vm.cagrVisible
                          ? "fa-square-check"
                          : "fa-square",
                      }),
                      _vm._v("\n                CAGR\n            "),
                    ]
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "dropdown mr-2" }, [
                    _c(
                      "button",
                      {
                        staticClass:
                          "btn btn-outline-secondary dropdown-toggle",
                        attrs: { type: "button", "data-toggle": "dropdown" },
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.denomination) +
                            "s\n                "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-menu" }, [
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.setDenomination("Million")
                            },
                          },
                        },
                        [_vm._v("Millions")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.setDenomination("Thousand")
                            },
                          },
                        },
                        [_vm._v("Thousands")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "dropdown-item",
                          on: {
                            click: function ($event) {
                              return _vm.setDenomination("Unit")
                            },
                          },
                        },
                        [_vm._v("Units")]
                      ),
                    ]),
                  ]),
                  _vm._v(" "),
                  _vm.pnlTemplates
                    ? _c("div", { staticClass: "btn-group" }, [
                        _c(
                          "button",
                          {
                            staticClass:
                              "btn btn-outline-secondary dropdown-toggle",
                            attrs: {
                              type: "button",
                              "data-toggle": "dropdown",
                            },
                          },
                          [_vm._v(_vm._s(_vm.pnlTemplateName))]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "dropdown-menu" },
                          [
                            _c("h6", { staticClass: "dropdown-header" }, [
                              _vm._v("P&L templates"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.pnlTemplates, function (t) {
                              return _c(
                                "a",
                                {
                                  key: t.Id,
                                  staticClass: "dropdown-item",
                                  on: {
                                    click: function ($event) {
                                      return _vm.setPnlTemplate(t.Id)
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(t.Name))]
                              )
                            }),
                          ],
                          2
                        ),
                      ])
                    : _vm._e(),
                ]
              ),
              _vm._v(" "),
              _c("PnlViewer", {
                attrs: {
                  readModel: _vm.rm.Report,
                  cagrVisible: _vm.cagrVisible,
                },
              }),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }